<template>
  <div class="access-forbidden-container">
    <h1 class="access-forbidden-title">{{ $t("accessForbidden.title") }}</h1>
    <p>
      {{
        this.code == null ? $t("accessForbidden.message") : $t("errors." + code)
      }}
    </p>
    <button v-on:click="logout" class="btn btn-success">
      {{ $t("common.logout") }}
      <span>
        <i class="scf-logout"></i>
      </span>
    </button>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      code: this.$route.params.code ?? null,
    };
  },
  methods: {
    logout() {
      this.$keycloak.logout({ redirectUri: window.location.origin });
    },
  },
});
</script>

<style scoped>
.access-forbidden-container {
  text-align: center;
  padding: 10%;
}
.access-forbidden-title {
  color: brown;
}
</style>
